/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type ImageGenerationUpdatedImageStatus =
  (typeof ImageGenerationUpdatedImageStatus)[keyof typeof ImageGenerationUpdatedImageStatus];

export const ImageGenerationUpdatedImageStatus = {
  success: "success",
  failed: "failed",
  pending: "pending",
} as const;
